import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from "chart.js";
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export default function CaseDetectionTrends({ apiUrl = "/api/ncd/case-trends" }) {
	const [data, setData] = useState(null);
	useEffect(() => {
		let mounted = true;
		(async () => {
			try {
				const res = await fetch(apiUrl, { cache: 'no-store' });
				if (!res.ok) throw new Error();
				const json = await res.json();
				if (!mounted) return;
				setData(json);
			} catch {
				setData({
					months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
					htn: [120, 150, 130, 160, 170, 180],
					dm: [80, 90, 100, 110, 95, 120],
					cancer: [10, 12, 8, 9, 11, 13]
				});
			}
		})();
		return () => mounted = false;
	}, [apiUrl]);

	const chartData = {
		labels: data?.months || [],
		datasets: [
			{ label: "Hypertension", data: data?.htn || [], borderColor: "#5e72e4", backgroundColor: "rgba(94,114,228,0.06)", tension: 0.3, fill: true },
			{ label: "Diabetes Mellitus", data: data?.dm || [], borderColor: "#11cdef", backgroundColor: "rgba(17,205,239,0.06)", tension: 0.3, fill: true },
			{ label: "Cancer", data: data?.cancer || [], borderColor: "#f5365c", backgroundColor: "rgba(245,54,92,0.06)", tension: 0.3, fill: true },
		]
	};
	const options = { maintainAspectRatio: false,responsive: true, plugins: { legend: { position: 'bottom' } }, scales: { x: { ticks: { color: "#525f7f" } }, y: { beginAtZero: true, ticks: { color: "#525f7f" } } } };

	return (
		<div className="card shadow-sm border-0 mt-3">
			<div className="card-body p-2">
				<h6 className="text-gray-800 font-semibold fs-6 mb-2">Monthly New Cases (HTN / DM / Cancer)</h6>
				<div style={{ height: 200 }}><Line data={chartData} options={options} /></div>
			</div>
		</div>
	);
}
